"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = require("prop-types");
const xstate_1 = require("xstate");
const react_2 = require("@xstate/react");
const intl_1 = require("@kyruus/intl");
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../../lib/messages"));
const proptypes = {
    /** The config object for the customer */
    config: prop_types_1.object.isRequired,
    /** The state machine of the current page  */
    service: (0, prop_types_1.instanceOf)(xstate_1.Interpreter).isRequired,
    /** Tracking function */
    track: prop_types_1.func.isRequired
};
const MobileAltProvidersComponent = ({ config, service, track }) => {
    const [state] = (0, react_2.useService)(service);
    const { altProviders, services } = state.context;
    const detailedAltProviders = (0, react_1.useMemo)(() => {
        if (!altProviders) {
            return [];
        }
        return altProviders.map((providerResult) => {
            return {
                availability: providerResult.availability,
                config,
                location: providerResult.locations[0],
                provider: providerResult.provider
            };
        });
    }, [altProviders, config]);
    if (detailedAltProviders.length === 0) {
        return null;
    }
    return (react_1.default.createElement(styles_1.MobileAltProvidersContainer, { "data-testid": "dbw-mobile-alt-providers" },
        react_1.default.createElement(styles_1.MobileAltProvidersHeader, null,
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.altProvidersHeader))),
        react_1.default.createElement(styles_1.MobileAltProviders, { createAvailabilityUrl: services.createAvailabilityUrl, createProviderUrl: services.createProviderUrl, providers: detailedAltProviders, track: track })));
};
MobileAltProvidersComponent.propTypes = proptypes;
exports.default = MobileAltProvidersComponent;
//# sourceMappingURL=MobileAltProviders.js.map